<template>
  <div id="update-files-dialog">
    <ipub-model :title="'Update Files'"
                width="900px"
                :visable="isVisable"
                :showFooter="false"
                @cancel="cancel">
      <div class="flex"
           style="flex-wrap: wrap;justify-content: space-between;">
        <div class="mar-b-10"
             style="width:49%"
             v-for="item in fileTypes"
             :key="item.id">
          <div class="ipub-p1 mar-b-4 relative">
            {{item.typeName}}
            <font v-if="item.required"
                  class="key-color">*</font>
            <ipub-tooltip placement="right"
                          type="dark"
                          class="mar-l-10">
              <div slot="title">{{item.typeFile}}</div>
              <ipub-icon type="iconInfo" />
            </ipub-tooltip>
            <!-- <div v-if="!(files[item.id]&&files[item.id].length)"
                 class="right-option link-color">
              <ipub-upload @change="(e)=>{upload(e, item)}">
                <a>Add</a>
              </ipub-upload>
            </div> -->
          </div>
          <template>
            <div class="ipub-border ipub-p4 mar-b-4 relative">
              <font v-if="files[item.id]&&files[item.id].length"
                    class="line-h-40 mar-l-10">{{files[item.id][0].name}}</font>
              <ipub-upload class="line-h-40 mar-l-10 line-color ipub-c-p"
                           style="display:block"
                           v-else
                           @change="(e)=>{upload(e, item)}">
                {{item.typeName}}
              </ipub-upload>
              <!-- <font v-else
                    class="line-h-40 mar-l-10 line-color">{{item.typeName}}</font> -->
              <div class="right-option"
                   v-if="files[item.id]&&files[item.id].length">
                <ipub-tooltip placement="bottomLeft">
                  <div slot="title">
                    Replace File
                  </div>
                  <ipub-upload @change="(e)=>{replace(e, item, files[item.id][0])}">
                    <a>
                      <ipub-icon class="line-h-40"
                                 style="font-size:24px;padding:0 10px"
                                 type="iconReplace" />
                    </a>
                  </ipub-upload>
                </ipub-tooltip>
                <ipub-tooltip v-if="!item.required"
                              placement="bottomLeft">
                  <div slot="title">
                    Delete File
                  </div>
                  <a @click="del(files[item.id][0])">
                    <ipub-icon class="line-h-40"
                               style="font-size:24px;padding:0 10px"
                               type="iconDelete" />
                  </a>
                </ipub-tooltip>
              </div>
            </div>
          </template>
        </div>
      </div>

    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mfile from '@/api/mfile'
import { getUploadConfig } from '@/utils/upload'
import manuscript from '@/api/manuscript'
import help from '@/utils/help'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      fileTypes: [],
      files: {},
      rest: 0,
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.dataSource = []
        this.files = {}
      } else {
        this.getTypes()
      }
    },
  },
  methods: {
    async getFiles () {
      const mfileList = await mfile.get({
        manuscriptId: this.inputData.id,
        sign: this.inputData.sign
      })
      this.files = {}
      if (mfileList && mfileList.length) {
        const MS = 200
        this.rest = MS * 1024 * 1024
        mfileList.forEach(item => {
          this.rest -= item.size
          this.files[item.itemCode] ? this.files[item.itemCode].push(item) : this.$set(this.files, item.itemCode, [item])
        })
      }
      this.$emit('confirm')
    },
    async getTypes () {
      this.fileTypes = await manuscript.ftype()
      this.getFiles()
    },
    async upload (files, item) {
      const data = await this.handleUpload(files, item)
      if (!data) {
        return
      }
      await mfile.manuscript(Object.assign(data, { type: 'ADD' }))
      this.$message.success({
        title: 'Success',
        content: 'File Uploaded Successfully'
      })
      this.getFiles()
    },
    async replace (files, item, val) {
      const data = await this.handleUpload(files, item, val)
      if (!data) {
        return
      }
      await mfile.manuscript(Object.assign(data, { type: 'UPDATE' }))
      this.$message.success({
        title: 'Success',
        content: 'File Replaced Successfully'
      })
      this.getFiles()
    },
    async del (val) {
      await mfile.manuscript(Object.assign(val, { type: 'DEL' }))
      this.$message.success({
        title: 'Success',
        content: 'This file has been deleted'
      })
      this.getFiles()
    },
    async handleUpload (files, item, val) {
      const file = files[0]
      const arr = file.name.split('.')
      let rightType = item.typeFile.includes(arr[arr.length - 1].toLowerCase())
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 200
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: 'Files can only be uploaded up to 200M, please compress and upload again'
        })
        return false
      }
      // let flag = false
      // if (val) {
      //   if (this.rest - file.size + val.size < 0) {
      //     flag = true
      //   }
      // } else {
      //   if (this.rest - file.size < 0) {
      //     flag = true
      //   }
      // }
      // if (flag) {
      //   this.$message.error({
      //     title: 'Error',
      //     content:
      //       'Files can only be uploaded up to 200M, please compress and upload again'
      //   })
      //   return false
      // }

      const path = `publisher/${this.publisherId}/manuscript/${this.inputData.id
        }/submit/${help.guid()}`

      const url = await getUploadConfig(file, path)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      const { name, size } = file
      const itemCode = item.id
      const lastTime = this.$moment()
      const { sign, id } = this.inputData
      const data = { name, size, itemCode, sign, manuscriptId: id, path: url, lastTime }
      if (val) {
        data.id = val.id
      }

      return data
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
